export const checkFinalApprove = (fromTypeId, positionId, forNext = null, item) => {
    if (
        fromTypeId === 1 ||
        fromTypeId === 2 ||
        fromTypeId === 9 ||
        fromTypeId === 10 ||
        fromTypeId === 12
      ) {
        if (positionId === 2) {
          return true
        }
        if (positionId === 5 || positionId === 3 || positionId === 4) {
          return true
        }
        if (positionId === 7 || positionId === 6) {
          return forNext ? true : false
        }
      }
      if (
        fromTypeId === 6 ||
        fromTypeId === 7 ||
        fromTypeId === 8 ||
        fromTypeId === 11
      ) {
        if (positionId === 2) {
          return true
        }
        if (positionId === 3) {
          return forNext ? true : false
        }
        if (positionId === 7 || positionId === 6 || positionId === 5) {
          return false
        }
      }
      if (fromTypeId === 3 || fromTypeId === 4 || fromTypeId === 5) {
        if (positionId === 2) {
          return true
        }
        if (positionId === 3) {
          return true
        }
        if (positionId === 5) {
          return forNext ? true : false
        }
        if (positionId === 7 || positionId === 6) {
          return false
        }
      }
      return null;
}